export default __webpack_public_path__ + "static/media/nas_logo.2c8efe6e.png";